import { apiFetch } from "./api";

export interface QuoteEventDto {
  quoteEventId: number;
  quoteId: number;
  eventKind: string;
  fromStatusCode: string | null;
  toStatusCode: string | null;
  comment: string | null;
  occurredOnUtc: string;
  actorUserName: string;
}

export const quoteEventsApi = {
  list: (quoteId: number, opts?: { type?: string; from?: string; to?: string }) => {
    const params = new URLSearchParams();
    if (opts?.type) params.set("type", opts.type);
    if (opts?.from) params.set("from", opts.from);
    if (opts?.to)   params.set("to",   opts.to);
    const qs = params.toString();
    return apiFetch<QuoteEventDto[]>(`/api/quotes/${quoteId}/events${qs ? "?" + qs : ""}`);
  },
};
